import { render, staticRenderFns } from "./HelloWorld.vue?vue&type=template&id=b9167eee&scoped=true&"
import script from "./HelloWorld.vue?vue&type=script&lang=js&"
export * from "./HelloWorld.vue?vue&type=script&lang=js&"
import style0 from "./HelloWorld.vue?vue&type=style&index=0&id=b9167eee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9167eee",
  null
  
)

export default component.exports